import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=0b907a6a&"
import script from "./Icon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports